import React from 'react';
import Footer from '../components/Footer';
import Reveal from '../components/Reveal';
import './LegalPage.css';

const NUM_COLOR = '#0284c7';

const sections = [
  { id: 's1', num: '1', title: 'Information We Collect', content: (
    <><p>We collect various types of information, including:</p>
    <ul className="styled-list">
      <li><strong>Personal Information:</strong> Name, email address, phone number, date of birth, and profile information</li>
      <li><strong>Educational Data:</strong> Course enrollment, progress, quiz results, and learning preferences</li>
      <li><strong>Technical Information:</strong> IP address, browser type, device information, and usage analytics</li>
      <li><strong>Payment Information:</strong> Processed securely via third-party payment gateways (we do not store card details)</li>
      <li><strong>Communication Data:</strong> Messages, feedback, and support interactions</li>
    </ul></>
  )},
  { id: 's2', num: '2', title: 'How We Use Your Information', content: (
    <ul className="styled-list">
      <li>Providing and improving our Services</li>
      <li>Personalizing your learning experience</li>
      <li>Processing transactions and sending related information</li>
      <li>Sending educational content and promotional materials</li>
      <li>Analyzing usage patterns and improving platform performance</li>
      <li>Responding to inquiries and providing customer support</li>
      <li>Complying with legal obligations</li>
    </ul>
  )},
  { id: 's3', num: '3', title: 'Information Sharing', content: (
    <><p>We do not sell, trade, or rent your personal information to third parties. However, we may share information with:</p>
    <ul className="styled-list">
      <li>Service providers who assist in platform operations</li>
      <li>Payment processors for transaction handling</li>
      <li>Legal authorities when required by law</li>
      <li>Other parties with your explicit consent</li>
    </ul></>
  )},
  { id: 's4', num: '4', title: 'Data Security', content: (
    <p>We implement industry-standard security measures to protect your personal information. This includes encryption, secure servers, and regular security audits. However, no method of transmission over the internet is completely secure.</p>
  )},
  { id: 's5', num: '5', title: 'Your Rights', content: (
    <ul className="styled-list">
      <li>Access your personal information</li>
      <li>Correct inaccurate data</li>
      <li>Request deletion of your information</li>
      <li>Opt-out of promotional communications</li>
      <li>Data portability</li>
    </ul>
  )},
  { id: 's6', num: '6', title: 'Cookies and Tracking', content: (
    <p>Our Services use cookies and similar tracking technologies to enhance your experience. You can control cookie settings through your browser preferences. For more information, see our Cookie Policy.</p>
  )},
  { id: 's7', num: '7', title: "Children's Privacy", content: (
    <p>Our Services are not directed to children under 13. We do not knowingly collect personal information from children. If we become aware that we have collected information from a child under 13, we will take steps to delete such information.</p>
  )},
  { id: 's8', num: '8', title: 'Changes to This Policy', content: (
    <p>We may update this Privacy Policy periodically. We will notify you of any significant changes by posting the new policy on our website and updating the "Last Updated" date.</p>
  )},
  { id: 's9', num: '9', title: 'Contact Us', content: (
    <><p>If you have questions about this Privacy Policy or our privacy practices, please contact us at:</p>
    <div className="legal-callout legal-callout--info">
      <p><strong>Email:</strong> <a href="mailto:support@abmeribaari.com">support@abmeribaari.com</a></p>
      <p><strong>Address:</strong> Ab Meri Baari, 63 B Saraswati Nagar, Indore, India — 452001</p>
    </div></>
  )},
];

function PrivacyPolicy() {
  return (
    <div>
      <header className="legal-hero legal-hero--privacy">
        <Reveal><span className="legal-hero-badge">🔒 Privacy Policy</span></Reveal>
        <Reveal delay={80}><h1>Your Privacy Matters to Us</h1></Reveal>
        <Reveal delay={160}><p>We are committed to protecting your personal information and being transparent about how we use it.</p></Reveal>
      </header>

      <div className="legal-body">
        <div className="legal-body-inner">
          {/* Sidebar TOC */}
          <aside className="legal-toc">
            <h4>Contents</h4>
            <ul className="legal-toc-list">
              {sections.map((s) => (
                <li key={s.id}><a href={`#${s.id}`}>{s.num}. {s.title}</a></li>
              ))}
            </ul>
          </aside>

          {/* Content */}
          <div className="legal-content">
            <div className="legal-updated">
              <strong>Effective Date:</strong> 01 May, 2026 &nbsp;·&nbsp; <strong>Last Updated:</strong> May 16, 2026
            </div>
            <p className="legal-intro">
              This Privacy Policy ("Policy") describes how Ab Meri Baari ("we," "us," "our," or "Company") collects, uses,
              discloses, and otherwise processes personal information in connection with our mobile applications, and
              services (collectively, the "Services").
            </p>

            {sections.map((s, i) => (
              <Reveal key={s.id} delay={i * 50}>
                <div className="legal-section" id={s.id}>
                  <div className="legal-section-head">
                    <div className="legal-section-num" style={{ background: NUM_COLOR }}>{s.num}</div>
                    <h2>{s.title}</h2>
                  </div>
                  {s.content}
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default PrivacyPolicy;
